import { useEffect, useState } from "react";
import { Container } from "../../../../components";
import { useForm } from "react-hook-form";
import { Form } from "react-bootstrap";
import { crearEspecie, getEspecie, updateEspecie } from "../handlers";
import "./style.css";
import { useParams } from "react-router-dom";
import SkeletonFormEspecie from "../../Skeletons/EspecieForm";

export default function FormEspecie({ type }) {
  const { id } = useParams();

  const [imagePreviewUrl, setImagePreviewUrl] = useState(null);
  const [changeImg, setChangeImg] = useState(false);

  const [rta, setRta] = useState({
    data: null,
    error: null,
    params: null,
    loading: false,
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
    setValue,
    reset,
    watch,
  } = useForm({
    defaultValues: {
      nombre: "",
      estado: 1,
      img_url: "",
    },
  });

  useEffect(() => {
    if (type == "update") {
      getEspecie(id, rta, setRta, reset);
    }
  }, []);

  const enviar = async (datos) => {
    datos.estado = datos.estado ? 1 : 0;
    let dataClean = datos;

    if (datos.img_url == undefined || datos.img_url == "") {
      delete dataClean.img_url;
    }

    if (type == "create") {
      crearEspecie(dataClean, rta, setRta, reset, setImagePreviewUrl);
    }
    if (type == "update") {
      updateEspecie(id, dataClean, rta, setRta);
    }
  };

  useEffect(() => {
    if (
      ((watch("img_url") != "" && type == "create") || (watch("img_url") && changeImg)) &&
      typeof (watch("img_url") == "object")
    ) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreviewUrl(reader.result);
      };
      reader.readAsDataURL(watch("img_url")[0]);
    }
  }, [watch("img_url")]);

  return (
    <Container
      linkBack={"/especies"}
      titulo={type === "create" ? "Crear Especie" : "Editar Especie"}
      size={"sm"}
    >
      {rta.loading ? (
        <SkeletonFormEspecie />
      ) : (
        <Form noValidate onSubmit={handleSubmit(enviar)} className="px-2">
          <section className="row">
            <div className="col-12 col-md-6 mx-auto">
              <Form.Group className="col-12">
                <Form.Label>Nombre de especie</Form.Label>
                <Form.Control placeholder="Nombre de la especie" {...register("nombre")} />
                <Form.Control.Feedback className="mensajeError-sm mensajeError-md" type="invalid">
                  {errors.nombre?.message}
                </Form.Control.Feedback>
                {!errors.nombre?.message && <div style={{ height: "21px" }}></div>}
              </Form.Group>

              <Form.Group className="col-12">
                <Form.Label>Estado</Form.Label>
                <Form.Check
                  {...register("estado")}
                  type="switch"
                  id="custom-switch"
                  label={`${watch("estado") ? "Activado" : "Desactivado"}`}
                />
                <Form.Control.Feedback className="mensajeError-sm mensajeError-md" type="invalid">
                  {errors.estado?.message}
                </Form.Control.Feedback>
                {!errors.estado?.message && <div style={{ height: "21px" }}></div>}
              </Form.Group>
            </div>

            <div className="col-6">
              <Form.Group className="col-12 ">
                <Form.Label>Imagen especie</Form.Label>
                <Form.Control
                  type="file"
                  onClick={() => {
                    setChangeImg(true);
                  }}
                  accept=".jpg,.jpeg,.png"
                  {...register("img_url")}
                />
                <div className="preview-container border border-2 mt-2" style={{ height: "300px" }}>
                  {type == "create" && (
                    <>
                      {imagePreviewUrl ? (
                        <img
                          src={imagePreviewUrl}
                          alt="Image Preview"
                          style={{ width: "100%", height: "100%", objectFit: "contain" }}
                        />
                      ) : (
                        <div className="w-100 h-100 d-flex justify-content-center align-items-center">
                          <span>Cargue una imagen</span>
                        </div>
                      )}
                    </>
                  )}
                  {type == "update" && !imagePreviewUrl ? (
                    <img
                      src={watch("img_url")}
                      alt="Image Preview"
                      style={{ width: "100%", height: "100%", objectFit: "contain" }}
                    />
                  ) : (
                    <img
                      src={imagePreviewUrl}
                      alt="Image Preview"
                      style={{ width: "100%", height: "100%", objectFit: "contain" }}
                    />
                  )}
                </div>
                <Form.Control.Feedback className="mensajeError-sm mensajeError-md" type="invalid">
                  {errors.img_url?.message}
                </Form.Control.Feedback>
                {!errors.img_url?.message && <div style={{ height: "21px" }}></div>}
              </Form.Group>
            </div>
          </section>

          <div className="d-flex justify-content-between">
            <button type="submit" className="btn btn-sm btn-success d-flex">
              Guardar{" "}
              {rta.loading && (
                <div className="d-flex justify-content-center">
                  <div className="spinner-border text-primary" role="status"></div>
                </div>
              )}
            </button>
          </div>
        </Form>
      )}
    </Container>
  );
}
